<template>
  <div>
    <div class="modal fade" id="modal-supplier-detail">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="onCloseSupplierDetailModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  supplierData.id === 0
                    ? "supplierManagement.addNew"
                    : "supplierManagement.detail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="">{{
                  $t("supplierManagement.supplierName")
                }}</label>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="supplierData.supplierName"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <label for="">{{
                  $t("supplierManagement.supplierAddress")
                }}</label>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="supplierData.supplierAddress"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="">{{
                      $t("supplierManagement.supplierEmail")
                    }}</label>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="supplierData.supplierEmail"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{
                      $t("supplierManagement.supplierPhone")
                    }}</label>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="supplierData.supplierPhone"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <label for="">{{
                  $t("supplierManagement.supplierNote")
                }}</label>
                <div class="form-group">
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="6"
                    v-model="supplierData.supplierNote"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onSave()"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseSupplierDetailModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions } from "vuex";
import utils from "@/lib/utils";
export default {
  components: {},
  data: () => ({
    supplierData: {
      id: 0,
      supplierCode: null,
      supplierName: null,
      supplierAddress: null,
      supplierEmail: null,
      supplierPhone: null,
      supplierNote: null
    }
  }),
  methods: {
    onCloseSupplierDetailModal: function() {
      $("#modal-supplier-detail").modal("hide");
    },
    onShowSupplierDetailModal: function() {
      $("#modal-supplier-detail").modal("show");
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onAddNewSupplier: function() {
      this.onShowSupplierDetailModal();
      this.supplierData = {
        id: 0,
        supplierCode: null,
        supplierName: null,
        supplierAddress: null,
        supplierEmail: null,
        supplierPhone: null,
        supplierNote: null
      };
    },
    onUpdateSupplier: function(data) {
      this.supplierData = {
        id: data.id,
        supplierCode: data.supplierCode,
        supplierName: data.supplierName,
        supplierAddress: data.supplierAddress,
        supplierEmail: data.supplierEmail,
        supplierPhone: data.supplierPhone,
        supplierNote: data.supplierNote
      };
      this.onShowSupplierDetailModal();
    },
    validateData: function() {
      let validateResults = "OK";
      for (let key in this.supplierData) {
        if (key === "supplierName") {
          if (utils.isEmptyString(this.supplierData[key])) {
            validateResults = this.$t("supplierManagement." + key);
            break;
          }
        }
        if (key === "supplierPhone") {
          if (
            !utils.isEmptyString(this.supplierData[key]) &&
            !utils.validatePhone(this.supplierData[key].replace(/ /g, ""))
          ) {
            validateResults = this.$t("user.inform_modal[0].phone_number_error");
            break;
          }
        }
        if (key === "supplierEmail") {
          if (
            !utils.isEmptyString(this.supplierData[key]) &&
            !utils.validateEmailAddress(this.supplierData[key])
          ) {
            validateResults = this.$t("user.inform_modal[0].email_error");
            break;
          }
        }
      }
      return validateResults;
    },
    onSave: function() {
      let results = this.validateData();
      if (results === "OK") {
        let data = {
          id: this.supplierData.id,
          supplierName: this.supplierData.supplierName,
          supplierAddress: this.supplierData.supplierAddress,
          supplierEmail: this.supplierData.supplierEmail,
          supplierPhone: this.supplierData.supplierPhone,
          supplierNote: this.supplierData.supplierNote
        };
        if (this.supplierData.id === 0) {
          this.CREATE_ASSET_SUPPLIER(data)
            .then(
              function() {
                this.isLoading = false;
                this.$emit("callbackSupplierList", true);
                this.onCloseSupplierDetailModal();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.showError(error.response.data.message);
              }.bind(this)
            );
        } else {
          this.UPDATE_ASSET_SUPPLIER(data)
            .then(
              function() {
                this.isLoading = false;
                this.$emit("callbackSupplierList", true);
                this.onCloseSupplierDetailModal();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.showError(error.response.data.message);
              }.bind(this)
            );
        }
      } else {
        this.showError(results);
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "CREATE_ASSET_SUPPLIER",
      "UPDATE_ASSET_SUPPLIER"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Property/SupplierDetailModal.vue